const collapseBtn = document.querySelector('[data-collapse-btn]');
const collapseText = document.querySelector('[data-collapse-text]');
const arrowUp = document.querySelector('[data-arrow-up]');
const arrowDown = document.querySelector('[data-arrow-down]');

let isOpen = false;

const handleCollapse = (e) => {
  if (!isOpen) {
    collapseText.style.height = collapseText.scrollHeight + "px";
    arrowUp.style.display = 'none';
    arrowDown.style.display = 'block';
    isOpen = !isOpen;
  } else {
    collapseText.style.height = "0px";
    arrowUp.style.display = 'block';
    arrowDown.style.display = 'none';
    isOpen = !isOpen;
  }
}

collapseBtn.addEventListener('click', handleCollapse);
